import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { SCREEN_SIZE_ORDER } from './constants';
import { screenSizeSelector } from './selectors';

function useScreenMinWidth(minWidthValues) {
	const currentScreenSize = useSelector(screenSizeSelector);
	// eslint-disable-next-line consistent-return
	return useMemo(() => {
		// eslint-disable-next-line no-cond-assign
		for (let i = 0, screenSize, value; (screenSize = SCREEN_SIZE_ORDER[i]); i += 1) {
			if (screenSize in minWidthValues) {
				value = minWidthValues[screenSize];
			}
			if (currentScreenSize === screenSize) {
				return value;
			}
		}
	}, [currentScreenSize]);
}

export default useScreenMinWidth;
